import { FormGroup } from '@angular/forms';
import { Component, OnDestroy } from '@angular/core';
import { catchError, filter, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription, throwError } from 'rxjs';

import { AuthService } from '../../+auth/shared/auth.service';
import { LoginFormFactory } from '../shared/login-form.factory';
import { AuthRepository } from '../../+auth/shared/auth.repository';
import { IconsService } from '@shared/modules/icons/shared/icons-service/icons.service';
import { LocalStorageService } from 'src/app/+auth/shared/local-storage.service';

@Component({
  selector: 'wb-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnDestroy {
  hidePassword$ = new BehaviorSubject(true);
  isLoading$ = new BehaviorSubject(false);
  isError$ = new BehaviorSubject(false);
  form: FormGroup = this.loginFormFactory.init();
  private subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private iconService: IconsService,
    private authRepository: AuthRepository,
    private lsService: LocalStorageService,
    private loginFormFactory: LoginFormFactory
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  login(event: SubmitEvent): void {
    this.isLoading$.next(true);

    this.subscription.add(
      this.authRepository
        .login(this.form.value)
        .pipe(
          filter((response) => !!response.accessToken),
          tap(({ accessToken }) =>
            this.lsService.setItem(LocalStorageService.jwtKey, accessToken)
          ),
          catchError((error) => this.loginError(error))
        )
        .subscribe(() => this.loginSuccess())
    );

    event.preventDefault();
  }

  loginSuccess(): void {
    this.isError$.next(false);
    this.authService.loginSuccess();
  }

  loginError(error: unknown): Observable<never> {
    this.isError$.next(true);
    this.isLoading$.next(false);
    return throwError(() => error);
  }

  getSvgIconPasswordValue(hidePasswordValue: boolean): string {
    return this.iconService.getSvgIconPasswordValue(hidePasswordValue);
  }
}
